import { Icon } from '../../../../components'
import { Button } from '../../../../components/button'

export function ToggleButton({
  seeMore,
  setSeeMore,
}: {
  seeMore: boolean
  setSeeMore: (value: React.SetStateAction<boolean>) => void
}) {
  return (
    <Button
      theme="link"
      size="small"
      onClick={() => {
        setSeeMore((prev) => !prev)
        window.gtag?.('event', 'click', {
          event_category: 'stocks-why-moving',
          event_label: seeMore ? 'show-less' : 'show-more',
        })
      }}
      className="inline-flex"
      rightContent={<Icon name={seeMore ? 'chevronUp' : 'chevronDown'} width={16} />}
    >
      {seeMore ? 'Less' : 'More'}
    </Button>
  )
}
